import React, { PureComponent } from 'react'
import cn from 'classnames'
import { FieldInputProps } from 'react-final-form'

type TOption = string | number

export interface RadioProps
  extends Partial<FieldInputProps<string, HTMLInputElement>> {
  label?: string
  option?: TOption
  visuallyHiddenLabel?: boolean
  onChange?: (option?: TOption) => void
}

export default class Radio extends PureComponent<RadioProps> {
  handleChange = (_e: unknown) => {
    const { disabled, option, onChange } = this.props

    return !disabled && onChange?.(option)
  }

  render() {
    const {
      checked,
      className,
      disabled,
      label,
      name,
      option,
      visuallyHiddenLabel,
    } = this.props

    const classes = cn({
      [className]: className,
      'mc-input-radio': true,
      'mc-input-radio--checked': checked,
      'mc-input-radio--disabled': disabled,
      'mc-mb-2': true,
    })

    return (
      <label className={classes} htmlFor={`${name}-${option}-label`}>
        <div>
          <input
            id={`${name}-${option}-label`}
            type='radio'
            name={name}
            className='mc-input-radio__realbox'
            value={option}
            disabled={disabled}
            checked={checked}
            onChange={this.handleChange}
            aria-hidden
          />
          <span
            className='mc-input-radio__fauxbox mc-mr-3'
            role='radio'
            aria-checked={checked}
            aria-labelledby={`${name}-${option}-label`}
          />
        </div>
        {!!label && (
          <span className={cn({ 'mc-sr-only': visuallyHiddenLabel })}>
            {label}
          </span>
        )}
      </label>
    )
  }
}
